import React from 'react';
import { Typography } from '@mui/material';
import HoldTable from '../tables/HoldTable';

const HoldSection = () => {
  return (
    <>
      <Typography marginRight={1} marginTop={2} variant='h3'>
        Hold
      </Typography>
      <HoldTable />
    </>
  );
};

export default HoldSection;
